import {Directive, ElementRef, HostListener, Input} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';

@Directive({
  selector: '[appHoverTooltip]'
})
export class HoverTooltipDirective {

  @Input() key: string;
  @Input() selectKey: string;
  @Input() left: string;
  @Input() top: string;
  @Input() width: string;
  @Input() height: string;
  constructor(private el: ElementRef, private router: Router) {

  }

  @HostListener('mouseenter')
  createRedirectLink() {


    const div = document.createElement('div');
    this.el.nativeElement.style.position = 'relative'
    // div.style.visibility = 'hidden';
    div.className = 'hover-shit';
    if (this.top) {
      div.style.top = `${this.top}`;
    }
    if (this.left) {
      div.style.left = `${this.left}`;
    }
    if (this.width) {
      div.style.width = `${this.width}`;
    }

    if (this.height) {
      div.style.height = `${this.height}`;
    }

    const text = document.createTextNode(this.key);
    div.appendChild(text);
    const closestElement = this.el.nativeElement.closest('div');
    // Mỗi Barcode trên một dòng Tối đa 50 mã vạch [Xem thêm]
    closestElement.appendChild(div);
    div.addEventListener('click', () => {
      this.router.navigate(['/business/guide'] , {queryParams : {key: this.selectKey}});
      // this.router.navigate(['/business/guide'] );
    });
  }

  @HostListener('mouseout')
  destroyHover() {
    const check = document.querySelectorAll('.hover-shit');
    if (check.length > 0) {
      check.forEach((item: HTMLElement) => {
        setTimeout(() => {
          item.remove();

        }, 3000);

      });
    }
  }
}
